import HttpRequest from "./http_request";

class UserProvider extends HttpRequest {
    async changePassword(data) {
        return this.update("/users/change-password", data);
      }
}

export default UserProvider;